export class QuickKeyFilter {
  storeId?: string | null;
  start?: number | null;
  limit?: number | null;

  constructor(init?: Partial<QuickKeyFilter>) {
    Object.assign(this, init);
  }

  getQuery(): string {
    let q = '';
    q += this.storeId ? '&store_id=' + this.storeId : '';
    q += this.start ? '&start=' + this.start : '';
    q += this.limit ? '&limit=' + this.limit : '';
    q = q ? '?' + q.substring(1) : '';
    return q;
  }
}
